<template>
  <div class="">

    <MarketHeader
      :selectedHeader="useHeader"
    />
    <main>
      <router-view></router-view>
    </main>

    <OurClientsSection />

    <HealthSpecialistSection />

    <FooterMenuSection />

    <MarketFooter v-if="useFooter" />

		<BackGround/>

		<BackToTop/>

  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";

import MarketHeader from '@/components/header/header.vue';
import MarketFooter from '@/components/footer/footer.vue';

import BackToTop from '@/components/design/backToTop.vue';
import BackGround from '@/components/design/background.vue';

import OurClientsSection from '@/components/home/sections/ourClients/ourClientsSection.vue';
import HealthSpecialistSection from '@/components/home/sections/healthSpecialist/healthSpecialistSection.vue';
import FooterMenuSection from '@/components/home/sections/footerMenu/footerMenuSection.vue';

export default defineComponent({
  name: "BlogLayout",
  components: {
    MarketHeader,
    MarketFooter,
    OurClientsSection,
    HealthSpecialistSection,
    FooterMenuSection,
		BackToTop,
		BackGround,
  },
  setup() {

    return {
      useHeader: "defaultHeader",
      useFooter: true,
    };
  },
});

</script>

<style scoped>
	@import '../assets/css/helper.css';
	@import '../assets/css/responsive.css';
	@import '../assets/css/style.css';
</style>
